import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { BookPlus, List, Users, Wallet } from "lucide-react";

const TeamView = () => {
  const navigate = useNavigate();
  const { id, role } = useParams(); // Extract ID and Role from URL
  const [searchQuery, setSearchQuery] = useState("");
  const [subordinates, setSubordinates] = useState([]);
  const [loading, setLoading] = useState(false);

  const [debitValues, setDebitValues] = useState({});
  const [creditValues, setCreditValues] = useState({});

  const storedRole = localStorage.getItem("role");
  const storedUid = localStorage.getItem("uid");

  const userId = id || storedUid;
  const userRole = role || storedRole;

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [modalSelectedUser, setModalSelectedUser] = useState(null);
  const [modalAmount, setModalAmount] = useState(0);
  const [modalActualGivenAmount, setModalActualGivenAmount] = useState(0);

  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalType2, setModalType2] = useState(null);
  const [modalSelectedUser2, setModalSelectedUser2] = useState(null);
  const [modalAmount2, setModalAmount2] = useState(0);
  const [modalActualGivenAmount2, setModalActualGivenAmount2] = useState(0);

  const [transactionType, setTransactionType] = useState("bonus");
  const [transactionType2, setTransactionType2] = useState("bonus");

  const openModal = (userId, type) => {
    setModalSelectedUser(userId);
    setModalType(type);
    setModalOpen(true);
  };
  const openModal2 = (userId, type) => {
    setModalSelectedUser2(userId);
    setModalType2(type);
    setModalOpen2(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setModalAmount("");
  };
  const closeModal2 = () => {
    setModalOpen2(false);
    setModalAmount2("");
  };

  const roleTabs = {
    admin: ["agent", "operator", "shops", "manager", "cashier", "user"],
    agent: ["operator", "shops", "manager", "cashier", "user"],
    operator: ["shops", "manager", "cashier", "user"],
    shops: ["manager", "cashier", "user"],
    manager: ["cashier", "user"],
    cashier: ["user"], // Only show 'user' button for cashier
  };
  const getNextRole = (currentRole) => {
    const roleHierarchy = {
      admin: "agent",
      agent: "operator",
      operator: "shops",
      shops: "manager",
      manager: "cashier",
      cashier: "user",
    };
    return roleHierarchy[currentRole] || null;
  };
  console.log(role);
  console.log(storedRole);
  const [selectedRole, setSelectedRole] = useState(
    role ? getNextRole(role) : getNextRole(storedRole)
  );
  const availableTabs = roleTabs[userRole] || [];

  const columns = {
    agent: [
      "S.No",
      "UID",
      "Parent_UID",
      "Name",
      "Email",
      "Password",
      "Available Credit",
      "Total Received Credit",
      "Total Distributed Credit",
      "Total Operators",
      "Total Shops",
      "Total Managers",
      "Total Cashiers",
      "Total Users",
      "Account Status",
      "Actions",
    ],
    operator: [
      "S.No",
      "UID",
      "Parent_UID",
      "Name",
      "Email",
      "Password",
      "Available Credit",
      "Total Received Credit",
      "Total Distributed Credit",
      "Total Shops",
      "Total Managers",
      "Total Cashiers",
      "Total Users",
      "Account Status",
      "Actions",
    ],
    shops: [
      "S.No",
      "UID",
      "Parent_UID",
      "Name",
      "Email",
      "Password",
      "Available Credit",
      "Total Received Credit",
      "Total Distributed Credit",
      "Total Managers",
      "Total Cashiers",
      "Total Users",
      "Account Status",
      "Actions",
    ],
    manager: [
      "S.No",
      "UID",
      "Parent_UID",
      "Name",
      "Email",
      "Password",
      "Available Credit",
      "Total Received Credit",
      "Total Distributed Credit",
      "Total Cashiers",
      "Total Users",
      "Account Status",
      "Actions",
    ],
    cashier: [
      "S.No",
      "UID",
      "Parent_UID",
      "Name",
      "Email",
      "Password",
      "Available Credit",
      "Total Received Credit",
      "Total Distributed Credit",
      "Total Users",
      "Account Status",
      "Actions",
    ],
    user: [
      "S.No",
      "Name",
      "Email",
      "Password",
      "UID",
      "Parent_UID",
      "Wallet Balance",
      "Actual Total Deposit",
      "Add By Admin",
      "Minus By Admin",
      "Total Bet",
      "Total Win",
      "Total Withdrawal",
      "Role",
      "Type",
      "User Status",
      "Account Status",
      "Actions",
    ],
  };

  const [page, setPage] = useState(1);
  const [limit] = useState(5); // or make it dynamic if needed
  const [totalPages, setTotalPages] = useState(1);


  const fetchData = async (page, limit) => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        // Fetch subordinates based on URL params
        const url = `https://api.trubetx.com/admin/getSubordinates/${userId}/${
          selectedRole || userRole
        }?page=${page}&limit=${limit}&search=${searchQuery}`; // Adjust page and limit as needed

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setSubordinates(response.data.data || []);
        setTotalPages(response?.data?.pagination?.totalPages || 1); // Set total pages from response
        setPage(response?.data?.pagination?.currentPage || 1); // Set current page from response
        
      } catch (error) {
        console.error("Error fetching data:", error.response?.data || error);
        setSubordinates([]);
      }
      setLoading(false);
    };

  useEffect(() => {   
    fetchData(1, 5);
  }, [id, selectedRole, role, searchQuery]); // Re-run API call when URL changes

  const handleClick = (userId, userRole) => {
    const nextRole = getNextRole(userRole); // Get the next role dynamically
    setSelectedRole(nextRole); // Update selectedRole before navigation
    navigate(`/subordinate/${userId}/${userRole}`); // Navigate to the new URL
  };
  const handleClick2 = (userId, userRole) => {
    const nextRole = getNextRole(userRole); // Get the next role dynamically
    setSelectedRole(nextRole); // Update selectedRole before navigation
    navigate(`/creditsHistory/${userId}`); // Navigate to the new URL
  };
  const handleClick3 = (userId, userRole) => {
    navigate(`/B2BDeposits/${userId}`); // Navigate to the new URL
  };

  const handleClick4 = (userId, userRole) => {
    navigate(`/TeamB2BDeposits/${userId}`); // Navigate to the new URL
  };

  const currentColumns = columns[selectedRole || "user"];

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // const filteredSubordinates = subordinates.filter((user) => {
  //   if (searchQuery.includes("user")) {
  //     // If searching for a user, filter by Name or Email
  //     return (
  //       user?.name?.toLowerCase().includes(searchQuery) ||
  //       user?.email?.toLowerCase().includes(searchQuery)
  //     );
  //   } else {
  //     // Otherwise, filter by Username or Email
  //     return (
  //       user?.username?.toLowerCase().includes(searchQuery) ||
  //       user?.email?.toLowerCase().includes(searchQuery)
  //     );
  //   }
  // });

  const handleAddAccount = () => {
    const newPath = `/addAccount`;
    navigate(newPath);
  };

  const handleCreditDebit = async (uid, action) => {
    try {
      // Ensure amount is correctly retrieved from state
      const amount = parseFloat(modalAmount2);
      const actualGivenAmount = parseFloat(modalActualGivenAmount2);

      if (!uid || isNaN(amount) || amount <= 0) {
        alert("Please enter a valid amount.");
        return;
      }

      const token = localStorage.getItem("token");

      // Ensure only primitive values are sent
      const requestData = {
        userId: uid,
        coin: "inr", // Fixed currency
        amount,
        action, // "credit" or "debit"
        transaction_type: action === "credit" ? transactionType2 : "penalty",
        actual_given_money:
          transactionType2 === "received_payment" ? actualGivenAmount : 0,
      };

      // Make API request
      const response = await axios.post(
        "https://api.trubetx.com/admin/manageCredit",
        requestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert(response.data.message);

      // Clear modal input
      setModalAmount2("");
      closeModal2();
      window.location.reload();
    } catch (error) {
      console.error("Error updating wallet balance:", error);
      alert("Failed to update balance.");
    }
  };

  const handleCreditDebitForUser = async (uid, action) => {
    try {
      // Ensure amount is correctly retrieved from state
      const amount = parseFloat(modalAmount);
      const actualGivenAmount = parseFloat(modalActualGivenAmount);

      if (!uid || isNaN(amount) || amount <= 0) {
        alert("Please enter a valid amount.");
        return;
      }

      const token = localStorage.getItem("token");

      // Ensure only primitive values are sent
      const requestData = {
        uid,
        coin: "inr", // Fixed currency
        amount,
        type: action, // "credit" or "debit"
        transaction_type: action === "credit" ? transactionType : "penalty",
        actual_given_money:
          transactionType === "received_payment" ? actualGivenAmount : 0,
      };

      // Make API request
      const response = await axios.post(
        "https://api.trubetx.com/admin/addBalanceForUser",
        requestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert(response.data.message);

      // Clear modal input
      setModalAmount("");
      closeModal();
      window.location.reload();
    } catch (error) {
      console.error("Error updating wallet balance:", error);
      alert("Failed to update balance.");
    }
  };



  return (
   <div className="ml-0 lg:ml-[230px] mt-4 bg-[#F5F5F4] pl-4 md:pl-0">
      <div className="flex items-center justify-between gap-1   rounded-t-lg">
        <div>
          <h2 className="text-xl font-medium text-[#292524]">
            Team Management
          </h2>
          <p className="mt-2">User / Team</p>
        </div>
        <div className="flex gap-1  mr-1">
          <input
            type="text"
            placeholder="Search by Name,Email"
            value={searchQuery}
            onChange={handleSearchChange}
            className="border-2 rounded-lg p-2 w-60 sm:mr-2 hidden sm:block bg-[#F5F5F4] text-gray-800 focus:outline-none focus:border-[#228BE6] transition duration-200 ease-in-out"
          />
          <button
            class="bg-[#228BE6]  text-white px-4 py-2 !rounded-[5px] transition duration-200 ease-in-out hover:bg-[#153223] active:bg-[#25ed87] focus:outline-none"
            onClick={() => handleAddAccount()}
          >
            Add Account
          </button>
        </div>
      </div>

      <div className="flex space-x-4 p-4 bg-white text-black rounded-lg mt-10">
        {availableTabs.map((r) => (
          <button
            key={r}
            className={`px-4 py-2 rounded-lg ${
              selectedRole === r ? "bg-[#228BE6] text-white" : "bg-[#F9FAFB]"
            }`}
            onClick={() => setSelectedRole(r)}
          >
            {r.charAt(0).toUpperCase() + r.slice(1)}s
          </button>
        ))}
      </div>

      <div className=" overflow-x-auto shadow-md rounded-[5px]">
        <table className="w-full text-sm text-left">
          <thead className="!text-[0.875rem] text-[#49556D] bg-[#FFFFFF] ">
            <tr>
              {currentColumns.map((col, index) => (
                <th key={index} className="px-6 py-3">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={currentColumns.length}
                  className="text-center py-4 text-white"
                >
                  Loading...
                </td>
              </tr>
            ) : (
              subordinates.map((user, index) => {
                switch (selectedRole) {
                  case "user":
                    return (
                      <tr
                        key={user.id}
                        className="bg-[#F9FAFB] border-b border-gray-200"
                      >
                        <td className="px-6 py-4 text-[#495057]">{index + 1}</td>
                        <td className="px-6 py-4 text-[#495057]">{user.name}</td>
                        <td className="px-6 py-4 text-[#495057]">{user.email}</td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.password2}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">{user.id}</td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.parent_id}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.user_balance}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.actual_total_deposit_amount}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.add_money_by_admin}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.minus_money_by_admin}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.total_bet_amount}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.total_win_amount}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          {user.total_withdrawals}
                        </td>

                        <td className="px-6 py-4 text-[#495057]">User</td>
                        <td className="px-6 py-4 text-[#495057]">{user.type}</td>
                        <td className="px-6 py-4 text-[#495057]">
                          <span
                            className={`h-2.5 w-2.5 rounded-full ${
                              user.user_status === "online"
                                ? "bg-[#228BE6]"
                                : "bg-red-500"
                            } mr-2`}
                          ></span>
                          {user.account_status === "offline"
                            ? "Offline"
                            : "Online"}
                        </td>
                        <td className="px-6 py-4 text-[#495057]">
                          <span
                            className={`h-2.5 w-2.5 rounded-full ${
                              user.account_status === 0
                                ? "bg-[#228BE6]"
                                : "bg-red-500"
                            } mr-2`}
                          ></span>
                          {user.account_status === 0 ? "Active" : "Blocked"}
                        </td>
                        <td className="px-6 py-4 text-[#495057] flex gap-4">
                          {/* Debit Icon (Subtract Money) */}
                          <FaMinusCircle
                            className="text-red-500 cursor-pointer text-xl"
                            onClick={() => openModal(user.id, "debit")}
                          />

                          {/* Credit Icon (Add Money) */}
                          <FaPlusCircle
                            className="text-green-500 cursor-pointer text-xl"
                            onClick={() => openModal(user.id, "credit")}
                          />
                          <BookPlus
                            className="text-green-600 hover:text-gray-100 cursor-pointer text-xl"
                            size={20}
                            onClick={() => handleClick2(user.id, user.role)}
                          />
                          <List
                            className="text-green-600 hover:text-gray-100 cursor-pointer text-xl"
                            size={20}
                            onClick={() => handleClick3(user.id, user.role)}
                          />
                        </td>
                      </tr>
                    );
                  default:
                    return (
                      <tr
                        key={user.id}
                        className="group bg-[#F9FAFB] border-b border-gray-200 hover:bg-gray-100"
                      >
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {index + 1}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.id}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.parent_id}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.username}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.email}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.password2}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.available_credit}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.total_received_credit}
                        </td>
                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          {user.total_distributed_credit}
                        </td>

                        {[
                          "agent",
                          "operator",
                          "shops",
                          "manager",
                          "cashier",
                        ].includes(selectedRole) && (
                          <>
                            {(
                              {
                                agent: [
                                  "operator",
                                  "shops",
                                  "manager",
                                  "cashier",
                                  "user",
                                ],
                                operator: [
                                  "shops",
                                  "manager",
                                  "cashier",
                                  "user",
                                ],
                                shops: ["manager", "cashier", "user"],
                                manager: ["cashier", "user"],
                                cashier: ["user"],
                              }[selectedRole] || []
                            ).map((role) => (
                              <td
                                key={role}
                                className="text-[#495057] group-hover:text-gray-800 py-4 px-6"
                              >
                                {user.hierarchyCounts?.[role] || 0}
                              </td>
                            ))}
                          </>
                        )}

                        <td className="text-[#495057] group-hover:text-gray-800 py-4 px-6">
                          <span
                            className={`h-2.5 w-2.5 rounded-full ${
                              user.account_status === 0
                                ? "bg-[#228BE6]"
                                : "bg-red-500"
                            } mr-2`}
                          ></span>
                          {user.account_status === 0 ? "Active" : "Blocked"}
                        </td>
                        <td className="px-6 py-4 flex items-center justify-center space-x-3 whitespace-nowrap">
                          {/* Debit Icon (Subtract Money) */}
                          <FaMinusCircle
                            className="text-red-500 hover:text-gray-100 cursor-pointer text-xl"
                            onClick={() => openModal2(user.id, "debit")}
                          />
                          {/* Credit Icon (Add Money) */}
                          <FaPlusCircle
                            className="text-green-500 hover:text-gray-100 cursor-pointer text-xl"
                            onClick={() => openModal2(user.id, "credit")}
                          />

                          <Users
                            className="text-green-600 hover:text-gray-100 cursor-pointer text-xl"
                            size={20}
                            onClick={() => handleClick(user.id, user.role)}
                          />
                          <BookPlus
                            className="text-green-600 hover:text-gray-100 cursor-pointer text-xl"
                            size={20}
                            onClick={() => handleClick2(user.id, user.role)}
                          />
                           <List
                            className="text-green-600 hover:text-gray-100 cursor-pointer text-xl"
                            size={20}
                            onClick={() => handleClick3(user.id, user.role)}
                          />
                           <List
                            className="text-green-600 hover:text-gray-100 cursor-pointer text-xl"
                            size={20}
                            onClick={() => handleClick4(user.id, user.role)}
                          />
                        </td>
                      </tr>
                    );
                }
              })
            )}
          </tbody>
          <tfoot>
  <tr>
    <td colSpan={16} className="py-4 px-6 text-start">
      <nav className="inline-flex items-center space-x-2">
        <button
          onClick={() => fetchData(page - 1, limit)}
          disabled={page <= 1}
          className={`px-4 py-2 rounded ${
            page <= 1
              ? "bg-gray-300 text-gray-600 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
        >
          Previous
        </button>
        <span className="text-gray-700 px-4 py-2">Page {page} of {totalPages}</span>
        <button
          onClick={() => fetchData(page + 1, limit)}
          disabled={page >= totalPages}
          className={`px-4 py-2 rounded ${
            page >= totalPages
              ? "bg-gray-300 text-gray-600 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
        >
          Next
        </button>
      </nav>
    </td>
  </tr>
</tfoot>

        </table>
      </div>
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-[#F9FAFB] rounded-lg shadow-lg p-6 w-1/3">
            <div className="flex justify-between items-center border-b pb-4">
              <h3 className="text-xl font-semibold text-white">
                {modalType === "credit" ? "Add Amount" : "Debit Amount"}
              </h3>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-600"
              >
                ×
              </button>
            </div>
            <div className="mt-4">
              <select
                className="w-full p-2 mt-2 rounded-lg bg-[#F9FAFB] text-white border border-gray-6000"
                value={modalType}
                onChange={(e) => setModalType(e.target.value)}
              >
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </select>
              {modalType === "credit" && (
                <select
                  className="w-full p-2 mt-2 rounded-lg bg-[#F9FAFB] text-white border border-gray-6000"
                  onChange={(e) => setTransactionType(e.target.value)}
                  value={transactionType}
                >
                  <option value="bonus">Bonus</option>
                  <option value="received_payment">Received Payment</option>
                </select>
              )}
              {transactionType === "received_payment" && (
                <input
                  type="number"
                  placeholder="Enter Actual received amount"
                  value={modalActualGivenAmount}
                  onChange={(e) => setModalActualGivenAmount(e.target.value)}
                  className="w-full p-2 mt-4 rounded-lg bg-transparent text-white border border-gray-600"
                />
              )}

              <input
                type="number"
                placeholder="Enter Credit amount"
                value={modalAmount}
                onChange={(e) => setModalAmount(e.target.value)}
                className="w-full p-2 mt-4 rounded-lg bg-transparent text-white border border-gray-600"
              />
              <div className="flex justify-end mt-4 space-x-2">
                <button
                  onClick={closeModal}
                  className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-[#000000]"
                >
                  Cancel
                </button>
                <button
                  onClick={() =>
                    handleCreditDebitForUser(modalSelectedUser, modalType)
                  }
                  className={`px-4 py-2 rounded-lg hover:bg-[#000000] ${
                    modalType === "credit" ? "bg-[#25ed87]" : "bg-red-500"
                  } text-white`}
                >
                  {modalType === "credit" ? "Credit" : "Debit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {modalOpen2 && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-[#F9FAFB] rounded-lg shadow-lg p-6 w-1/3">
            <div className="flex justify-between items-center border-b pb-4">
              <h3 className="text-xl font-semibold text-black">
                {modalType2 === "credit" ? "Add Amount" : "Debit Amount"}
              </h3>
              <button
                onClick={closeModal2}
                className="text-gray-400 hover:text-gray-600"
              >
                ×
              </button>
            </div>
            <div className="mt-4">
              <select
                className="w-full p-2 mt-2 rounded-lg bg-[#ffffff] text-black border border-gray-6000"
                value={modalType2}
                onChange={(e) => setModalType2(e.target.value)}
              >
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </select>
              {modalType2 === "credit" && (
                <select
                  className="w-full p-2 mt-2 rounded-lg bg-[#ffffff] text-black border border-gray-6000"
                  onChange={(e) => setTransactionType2(e.target.value)}
                  value={transactionType2}
                >
                  <option value="bonus">Bonus</option>
                  <option value="received_payment">Received Payment</option>
                </select>
              )}
              {transactionType2 === "received_payment" && (
                <>
                  <input
                    type="number"
                    placeholder="Enter Actual received amount"
                    value={modalActualGivenAmount2}
                    onChange={(e) => setModalActualGivenAmount2(e.target.value)}
                    className="w-full p-2 mt-4 rounded-lg bg-transparent text-black border border-gray-600"
                  />
                </>
              )}

              <input
                type="number"
                placeholder="Enter Credit amount"
                value={modalAmount2}
                onChange={(e) => setModalAmount2(e.target.value)}
                className="w-full p-2 mt-4 rounded-lg bg-transparent text-black border border-gray-600"
              />
              <div className="flex justify-end mt-4 space-x-2">
                <button
                  onClick={closeModal2}
                  className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-[#000000]"
                >
                  Cancel
                </button>
                <button
                  onClick={() =>
                    handleCreditDebit(modalSelectedUser2, modalType2)
                  }
                  className={`px-4 py-2 rounded-lg hover:bg-[#000000] ${
                    modalType2 === "credit" ? "bg-[#25ed87]" : "bg-red-500"
                  } text-white`}
                >
                  {modalType2 === "credit" ? "Credit" : "Debit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamView;
